import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  body {
    margin: 0;
  }
  @font-face {
    font-family: 'Magenos';
    src: url('/webfonts/magenos-black.woff2') format('woff2'), url('/webfonts/magenos-black.woff') format('woff');
    font-weight: 900;
    font-style: normal;
  }
  @font-face {
    font-family: 'Magenos';
    src: url('/webfonts/magenos-bold.woff2') format('woff2'), url('/webfonts/magenos-bold.woff') format('woff');
    font-weight: 600;
    font-style: normal;
  }
`;

export const white = 'rgba(255, 255, 255, 1)';
export const grey = 'rgba(199, 199, 199, 1)';
export const lightGrey = 'rgba(229, 229, 229, 1)';
export const mediumGrey = 'rgba(112, 112, 112, 1)';
export const anthracite = 'rgba(34, 34, 34, 1)';

export const black = 'rgba(0, 0, 0, 1)';

export const lighterGreen = 'rgba(0, 210, 164, 0.2)';
export const lightGreen = 'rgba(0, 210, 164, 1)';
export const green = 'rgba(0, 76, 60, 1)';
export const mediumGreen = 'rgba(2, 129, 102, 1)';

export const ecoleFrancaiseGreen = 'rgba(33, 129, 104, 1)'; // #218168
export const iPacRed = 'rgba(189, 45, 35, 1)';

export const yellow = 'rgba(255, 187, 0, 1)';
export const lightYellow = 'rgba(255, 204, 0, 0.15)';
export const blue = 'rgba(0, 115, 255, 1)';
export const lightBlue = 'rgba(0, 115, 255, 0.15)';
export const orange = 'rgba(255, 143, 0, 1)';
export const lightOrange = 'rgba(255, 187, 0, 0.15)';
export const red = 'rgba(255, 95, 119, 1)';

export const fontFamilyRoboto = "'Roboto', Times,  sans-serif !important";
export const fontFamilyMagenos = "'Magenos', sans-serif !important";

/**
 * definir des breakpoints mobile first
 */
const size = {
  xs: '0px', // for small screen mobile
  sm: '600px', // for mobile screen
  md: '960px', // for tablets
  lg: '1280px', // for laptops
  xl: '1440px', // for desktop / monitors
  xxl: '1920px', // for big screens
  mobile: '0px',  // short code pour le mobile
  tablet: '640px', //short code pour les tablettes
  laptop: '1025px', // actuellement ceci est utilisé comme breakpoint principal dans le code (1024)
  desktop: '1200px',
};

/**
 * dans le code on pourra juste faire
 * @media ${device.laptop} {
 *  display: none
 * }
 * pour cacher tout ce qui a une taille minimale de size.laptop
 */
export const device = {
  xs: `(min-width: ${size.xs})`,
  sm: `(min-width: ${size.sm})`,
  md: `(min-width: ${size.md})`,
  lg: `(min-width: ${size.lg})`,
  xl: `(min-width: ${size.xl})`,
  xxl: `(min-width: ${size.xxl})`,
  mobile: `(min-width: ${size.mobile})`,
  tablet: `(min-width: ${size.tablet})`,
  laptop: `(min-width: ${size.laptop})`,
};
